import React, { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";

import { GetUserModel } from "../../ApiServices/Profile/ProfileApi";

import toast from "react-hot-toast";
import LoginPopUp from "../LoginPopup";
import batuk from "../../assets/images/new/fav-removebg-preview.png";
import astrology from "../../assets/images/new/astrology.png";
import panchang from "../../assets/images/new/panchang.png";
import numerology from "../../assets/images/new/numerology.png";
import zodiacSign from "../../assets/images/new/zodiacSign.png";
import Astro from "../../assets/images/new/services1 (1).jpg";
import Panchang from "../../assets/images/new/services1 (2).jpg";
import Numerology from "../../assets/images/new/services1 (3).jpg";
import Prediction from "../../assets/images/new/services1 (1).jpg";
import { t } from "i18next";


const HoroscopeListCards = () => {
  const navigate = useNavigate();
  const [showProfile, setProfile] = useState(false);
  const [modelRequestData, setModelRequestData] = useState({ Route: null })
  const [showOpenLoginModal, setShowOpenLoginModal] = useState(false);
  const ItemAddedToast = () => toast("Please Update Your Profile");
  const userID = localStorage.getItem("userID");

  const GetUserModelData = async (value) => {
    // setLoader(true);

    const userID = JSON.parse(localStorage.getItem("userID"));
    if (userID === null || userID === undefined) {
      // navigate("/");
      setShowOpenLoginModal(true);
    }
    try {
      const response = await GetUserModel(userID);
      if (response?.ResponseCode == 0) {
        // setLoader(false);
        const ModelData = response.DATA || []; // Assuming the data is an array and we need the first item
        if (
          ModelData[0]?.DOB === null ||
          ModelData[0]?.DOB === undefined ||
          ModelData[0]?.DOB === ""
        ) {
          ItemAddedToast();
          navigate("/horoscope/my-profile", {
            state: { modelName: "Horoscope" },
          });
        } else {
          navigate(value?.route);
        }
      } else {
        // setLoader(false);

        console.error(
          "Error fetching data: ",
          response?.data?.data?.statusCode
        );
      }
    } catch (error) {
      // setLoader(false);

      console.error("Error", error);
    }
  };

  const handleClick = (value) => {
    GetUserModelData(value);
  };

  const services = [
    {
      title: t("Astrology"),
      image: Astro,
      icon: astrology,
      text: t("Book Astrology for your spiritual rituals and ceremonies."),
      color: "#ffa415",
      route: "/basic-details",
    },
    {
      title: t("Panchang"),
      image: Panchang,
      icon: panchang,
      text: t("Get a Panchang for your up and down "),
      color: "#fc5528",
      route: "/daily-panchang",
    },
    {
      title: t("Numerology"),
      image: Numerology,
      icon: numerology,
      text: t("Numerology for better life"),
      color: "#8139e7",
      route: "/numerology",
    },
    {
      title: t("Prediction"),
      image: Prediction,
      icon: zodiacSign,
      text: t("Know about Prediction"),
      color: "#399be7",
      route: "/Prediction ",
    }
  ];


  const handleBtnClicked = (value) => {

    if (userID === null || userID === undefined || userID === '') {
      setModelRequestData((prev) => ({ ...prev, Route: value.route }))
      setShowOpenLoginModal(true)
    } else {
      navigate(`${value.route}`, { state: { key: value.key } });
    }
  }
  const handleOnConfirm = () => {
    navigate(`${modelRequestData?.Route}`)
  };
  return (
    <>
      <section className="service-two">
        <div className="service-two__shape"></div>
        <div
          className="container"
          style={{ display: "flex", flexDirection: "column" }}
        >
          <div className="section-title text-center">
            <h6
              className="sec-title__tagline bw-split-in-right"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img className="tagline-img" src={batuk} alt="" />
              {t("Horoscope Services")}
            </h6>
            <h3
              className="sec-title__title bw-split-in-left"
              style={{ textAlign: "center" }}
            >
              {/* Book Puja Services At your Fingertips */}
              {t("Your One-Stop Destination for Horoscope Services")}
            </h3>
          </div>
          <div className="row gutter-y-30" style={{ '--bs-gutter-x': '25px', '--bs-gutter-y': '35px' }}>
            {services.map((service, index) => (
              <div
                key={index}
                style={{ cursor: "pointer" }}
                className="col-lg-3 col-md-6 wow fadeInUp"
                data-wow-delay={`${index * 100}ms`}
                onClick={() => {
                  handleBtnClicked(service)
                  window.scrollTo({ top: 0, behavior: "instant" }); // Instantly move to the top without scroll animation
                }}
              >
                <div
                  className="service-two__item text-center"
                  style={{
                    color: "black",
                    height: "100%", // Let it stretch
                    minHeight: "450px", // Adjust this value based on your design
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    className="service-two__item__shape"
                  // style={{
                  //   backgroundImage: "url(assets/images/new/leftside.png)",
                  // }}
                  ></div>
                  <div className="service-two__item__image">
                    <img
                      src={service.image}
                      alt="MyOm Namo"
                      style={{ width: "300px", objectFit: "cover" }}
                    />
                  </div>
                  <div className="service-two__item__icon">
                    <img
                      src={service?.icon}
                      alt=""
                      className="service_i"
                      style={{ borderRadius: "50%" }}
                    />
                  </div>
                  <h3
                    className="service-two__item__title"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {service.title}
                  </h3>
                  <p
                    className="service-two__item__text"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                  // style={{ color: "black" }}
                  >
                    {service.text}
                  </p>
                  <div className="service-two__item__rm">
                    {/* Navigate to the respective route */}
                    <Link onClick={() => handleBtnClicked(service)}>{t("Read More")}</Link>
                    <i className="icon-right-arrow"></i>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section >
      <LoginPopUp
        show={showOpenLoginModal}
        onHide={() => setShowOpenLoginModal(false)}
        onConfirm={handleOnConfirm}

      />
    </>
  );
};

export default HoroscopeListCards;
